<template>
  <div>
    {{slots.default ? slots.default(current) : timeText}}
  </div>
</template>

<script>
import {
  watch,
  computed,
  defineComponent,
} from 'vue';
import { parseFormat, useCountDown } from './count-down';

export default defineComponent({
  name: 'countDown',
  props: {
    autoStart: {
      type: Boolean,
      default: true,
    },
    millisecond: Boolean,
    time: {
      type: [Number, String],
      default: 0,
    },
    format: {
      type: String,
      default: 'HH:mm:ss',
    },
  },
  emits: ['change', 'finish'],
  setup(props, { emit, slots }) {
    const {
      start,
      pause,
      reset,
      current,
    } = useCountDown({
      time: +props.time,
      millisecond: props.millisecond,
      onChange: (val) => emit('change', val),
      onFinish: () => emit('finish'),
    });

    const timeText = computed(() => parseFormat(props.format, current.value));

    const resetTime = () => {
      reset(+props.time);

      if (props.autoStart) {
        start();
      }
    };

    watch(() => props.time, resetTime, { immediate: true });

    return {
      start,
      pause,
      reset: resetTime,
      timeText,
      slots,
    };
  },
});
</script>
